import { useEffect, useState } from "react";
import { useUser } from "src/shared/context/UserContext";
import { CustomerData } from "src/shared/services/interfacev2";
import { getCustomer } from "src/shared/services/servicesv2";

export const useCustomerSearch = (searchTerm: string, pageNumber: number) => {
  const [apiCustomers, setApiCustomers] = useState<CustomerData[]>([]);
  const [localAddedCustomers, setLocalAddedCustomers] = useState<CustomerData[]>([]);
  const [total, setTotal] = useState({ totalRecords: "0", totalPage: "0" });
  const [loading, setLoading] = useState(false);
  const { userConfigration } = useUser();

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setLoading(true);
      const pageSize = userConfigration?.tableDefaultSize || 10;
      getCustomer(
        false, // include_deleted
        pageNumber, // pageNumber
        pageSize, // pageSize
        searchTerm, // searchBy
        "", // sortField (optional)
        "", // sortOrder (optional)
      )
        .then((res) => {
          const data = res.data;
          // merge local added customers at the front
          setApiCustomers([...localAddedCustomers, ...data.customer_details]);
          setTotal({
            totalRecords: String(Number(data.totalRecords)),
            totalPage: String(Math.ceil(Number(data.totalRecords) / pageSize)),
          });
        })
        .catch(console.error)
        .finally(() => setLoading(false));
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchTerm, pageNumber, localAddedCustomers, userConfigration]);

  const addCustomerLocally = (customer: CustomerData) => {
    // Add locally
    setLocalAddedCustomers((prev) => [customer, ...prev]);
    // Update total
    setTotal((prev) => ({
      ...prev,
      totalRecords: String(Number(prev.totalRecords) + 1),
    }));
  };

  // Merge API + local customers BEFORE returning
  const customers = [...localAddedCustomers, ...apiCustomers];

  return { customers, total, loading, addCustomerLocally };
};
